import React, { useState, useEffect, useRef, useCallback } from 'react'
import { TailSpin } from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { CountryAutocomplete } from "./CountryAutocomplete";

import { sendMail } from "../lib/api-lib";

function CmsForm({ component, page_id='' }) {
  const [showModal, setShowModal] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [showResult, setShowResult] = useState(0);
  const [bottomReached, setbottomReached] = useState(false);
  const [privacyWarning, setPrivacyWarning] = useState(false);
  const [country, setCountry] = useState('');  // unused atm

  // https://github.com/t49tran/react-google-recaptcha-v3
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }

    return await executeRecaptcha(); // token
  }, [executeRecaptcha]);

  // You can use useEffect to trigger the verification as soon as the component being loaded
  // useEffect(() => {
  //   handleReCaptchaVerify();
  // }, [handleReCaptchaVerify]);


  const form_data = {
    name: '',
    email: '',
    phone: '',
    message: '',
    // billing_address: '',
    country: '',
  };

  const handleSubmit = async (event) => {
    // console.log(event);
    event.preventDefault();

    const token = await handleReCaptchaVerify();

    // console.log("TOKEN ::: ", token)

      const data = {
        name: event.target.name.value,
        email: event.target.email.value,
        phone: event.target.phone.value,
        subject: "Message from website",
        // billing_address: event.target.billing_address.value,
        country: event.target.country.value,
        message: event.target.message.value,
        token: token,
      };

      setShowLoading(true);

      // const response = await sendMail(data);

      fetch(process.env.BASE_URL + "/api/sendmail", {
        body: JSON.stringify(data),
        method: "POST",
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setShowLoading(false);
        if (data.response == 1) {
          setShowResult(1);
        } else {
          setShowResult(2);
        }
      })
      .catch((error) => {
        setShowLoading(false);
        setShowResult(2);
      });
  };

  const closeForm = () => {
    document.querySelector("body, html").classList.remove("no-scroll");
    setShowModal(false);
    setShowResult(0);
  };

  const listInnerRef = useRef();

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        setbottomReached(true);
        // console.log("reached bottom");
      }
    }
  };

  return (
    <>
      {showModal ? (
        <>
          <div className="contact-form">
            <h3 className="max-sm:text-2xl">Fill out the form below to contact us</h3>
            <div className="contact-form-container relative">
              {showResult == 0 ? (
                <>
                  {showLoading ? (
                    <div className="absolute w-full h-full theme-b5 z-10 flex flex-col justify-center items-center">
                      <TailSpin
                        type="Puff"
                        color="#15A1b1"
                        height={70}
                        width={70}
                        timeout={3000}
                      />
                      <div>sending...</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/*content*/}
                  <form className="w-full" onSubmit={handleSubmit}>
                    <div className="form-contact">
                      {/*body*/}
                      <div className="relative p-6 flex-auto">
                        <div className="form-row grid md:grid-cols-2 gap-4">
                          <div className="form-fld py-4">
                            <label
                              className="theme-c2 font-bold"
                              htmlFor="form_name"
                            >
                              Full name <span className="required">*</span>
                            </label>
                            <input
                              id="form_name"
                              className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 leading-tight focus:outline-none"
                              type="text"
                              placeholder=""
                              aria-label="Full name (required)"
                              name="name"
                              defaultValue={form_data.name}
                              required
                            />
                          </div>
                          <div className="form-fld py-4">
                            <label
                              className="theme-c2 font-bold"
                              htmlFor="form_name"
                            >
                              Country <span className="required">*</span>
                            </label>
                            <CountryAutocomplete
                              name="country"
                              // defaultValue={form_data.country}
                              required={true}
                              // setModelValue={(val) => form_data.country = val}
                            />
                          </div>
                        </div>
                        <div className="form-row grid md:grid-cols-2 gap-4">
                          <div className="form-fld py-4">
                            <label
                              className="theme-c2 font-bold"
                              htmlFor="form_name"
                            >
                              Phone
                            </label>
                            <input
                              id="form_phone"
                              className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 leading-tight focus:outline-none"
                              type="text"
                              placeholder=""
                              aria-label="Phone"
                              defaultValue={form_data.phone}
                              name="phone"
                            />
                          </div>
                          <div className="form-fld py-4">
                            <label
                              className="theme-c2 font-bold"
                              htmlFor="form_email"
                            >
                              Email <span className="required">*</span>
                            </label>
                            <input
                              id="form_email"
                              className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 leading-tight focus:outline-none"
                              type="email"
                              placeholder=""
                              aria-label="Email (obbligatorio)"
                              name="email"
                              defaultValue={form_data.email}
                              required
                            />
                          </div>
                        </div>
                        <div className="form-row py-4">
                          <label
                            className="theme-c2 font-bold"
                            htmlFor="form_message"
                          >
                            Message
                          </label>
                          <textarea
                            id="form_message"
                            className="appearance-none bg-transparent border-none w-full h-32 text-gray-700 mr-3 py-1 leading-tight focus:outline-none"
                            type="text"
                            placeholder=""
                            aria-label="Messaggio"
                            name="message"
                            defaultValue={form_data.message}
                          ></textarea>
                        </div>
                      </div>
                      {/*footer*/}

                      <div className="flex items-center justify-center pb-6 border-t border-solid border-slate-200 rounded-b relative">
                        <input type="checkbox" value="1" id="form_terms" name="terms" className="mr-4 cursor-pointer"
                        required
                        />
                          
                          <label
                            className={`font-bold cursor-pointer`}
                            htmlFor="form_terms"
                          >
                            I&apos;ve read and accepted all <a href="/terms-of-use" target="_blank">Terms of use</a>
                          </label>
                      </div>
                      <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                        <button className="externalBtn" type="submit">
                          SEND MESSAGE
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <div className="form-cms-container-inner">
                    <div className="relative p-6 flex-auto">
                      <div className="z-10 flex flex-col justify-center items-center">
                        {showResult == 1 ? (
                          <div id="contact-form-success">
                            <h5 className="theme-c2 text-center">
                              Thanks for contacting us!
                            </h5>
                            <p className="font-normal text-center">
                              We will respond to your request as soon as
                              possible
                            </p>
                            {/* <div className="mt-8 mb-12">
                              <button
                                className="sendBtn"
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  closeForm();
                                }}
                              >
                                Chiudi
                              </button>
                            </div> */}
                          </div>
                        ) : (
                          <div id="contact-form-error">
                            <h5 className="text-[var(--theme-color-2)] text-center">
                              An error has occurred :(
                            </h5>
                            <p className="font-normal mt-8 text-center">
                              We apologize for any inconvenience.
                              <br />
                              Please contact us by writing to{" "}
                              <a
                                href="mailto:info@tarponville.com"
                                className="theme-c2"
                              >
                                info@tarponville.com
                              </a>
                            </p>
                            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                              <button className="externalBtn" type="button" onClick={() => { setShowResult(0) }}>
                                RETRY
                              </button>
                            </div>
                            {/* <div className="mt-8 mb-12">
                              <button
                                className="sendBtn"
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  closeForm();
                                }}
                              >
                                Chiudi
                              </button>
                            </div> */}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}

export default CmsForm;
